'use client';

import { isNonNil, jsonAssignInlineVars } from '@vuddy/utils';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { Element, ElementProps } from '../element';
import { SizeKey, theme } from '../theme/theme.css';
import * as styles from './grid.css';

interface GridProps extends Omit<ElementProps, 'gap'> {
  gap?: SizeKey;
  gapRow?: SizeKey;
  gapColumn?: SizeKey;
  children?: ReactNode;
  className?: string;
  repeat: number;
}

export const Grid = ({
  children,
  gap = 'gap_gapless',
  gapColumn,
  gapRow,
  repeat,
  className,
  ...props
}: GridProps) => {
  return (
    <Element
      className={clsx(
        styles.grid,
        isNonNil(repeat) ? styles.repeatCount : undefined,
        className
      )}
      style={jsonAssignInlineVars({
        [styles.gapRow]: theme.size[gapRow ?? gap],
        [styles.gapColumn]: theme.size[gapColumn ?? gap],
        [styles.repeatCountVar]: repeat,
      })}
      {...props}>
      {children}
    </Element>
  );
};
